import PropTypes from 'prop-types'
import { Component } from 'react'
import { withRouter } from 'react-router-dom'
import routes, { getRouteFromPathname } from 'shared/routes'

// temporary until we port page elements to React
@withRouter
export default class ManagePageElements extends Component {
    static propTypes = {
        pageElements: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    }
    componentDidUpdate() {
        const { pageElements } = this.props

        if (pageElements) {
            pageElements.hide && this.managePageElements()
        }
    }
    managePageElements() {
        const {
            location: { pathname },
            pageElements: { hide },
        } = this.props
        const shouldHide = getRouteFromPathname(pathname) === routes.GIF_DETAIL
        hide.forEach(([el, display]) => {
            // channel-banner could be undefined, just do a check here
            if (el) {
                el.style.display = shouldHide ? 'none' : display
            }
        })
    }
    render() {
        return null
    }
}
